module.exports = __webpack_public_path__ + "static/media/what_img2.a393fef8.webp";